"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.githubAuthProvider = exports.twitterAuthProvider = exports.facebookAuthProvider = exports.googleAuthProvider = exports.currentUser = exports.auth = exports.db = void 0;

var _app = _interopRequireDefault(require("firebase/app"));

require("firebase/auth");

require("firebase/firestore");

var _FirebaseConfig = _interopRequireDefault(require("../configs/FirebaseConfig"));

_app.default.initializeApp(_FirebaseConfig.default); // firebase utils


var db = _app.default.firestore();

exports.db = db;

var auth = _app.default.auth();

exports.auth = auth;
var currentUser = auth.currentUser;
exports.currentUser = currentUser;
var googleAuthProvider = new _app.default.auth.GoogleAuthProvider();
exports.googleAuthProvider = googleAuthProvider;
var facebookAuthProvider = new _app.default.auth.FacebookAuthProvider();
exports.facebookAuthProvider = facebookAuthProvider;
var twitterAuthProvider = new _app.default.auth.TwitterAuthProvider();
exports.twitterAuthProvider = twitterAuthProvider;
var githubAuthProvider = new _app.default.auth.GithubAuthProvider();
exports.githubAuthProvider = githubAuthProvider;